import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck } from "@fortawesome/free-solid-svg-icons";

class VerificationSuccess extends Component {
  render() {
    return (
      <div style={styles.container}>
        <div style={styles.card}>
          <FontAwesomeIcon icon={faCircleCheck} style={styles.icon} />
          
          <h1 style={styles.title}>Verification Successful</h1>
          <p style={styles.message}>
            Your identity has been successfully verified.
          </p>

          {/* <button style={styles.button} onClick={this.handleContinue}>
            Continue
          </button> */}
        </div>
      </div>
    );
  }

  handleContinue = () => {
    console.log("Continue clicked");
  };
}

const styles: { [key: string]: React.CSSProperties } = {
  container: {
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "#f5f7fa",
  },
  card: {
    padding: "40px",
    borderRadius: "12px",
    background: "#ffffff",
    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
    textAlign: "center",
    width: "400px",
  },
  icon: {
    fontSize: "60px",
    color: "#2ecc71",
    marginBottom: "15px",
  },
  title: {
    margin: "10px 0",
    color: "#2ecc71",
  },
  message: {
    color: "#555",
    marginBottom: "20px",
  },
  button: {
    padding: "10px 20px",
    border: "none",
    borderRadius: "8px",
    background: "#2ecc71",
    color: "#fff",
    cursor: "pointer",
  },
};

export default VerificationSuccess;